"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Award05 = function Award05(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M7.1352 11.189 3.3304 4.3805c-.4375-.7828-.6562-1.1743-.6194-1.4948a1 1 0 0 1 .4091-.6972C3.3819 2 3.8303 2 4.7271 2H6.962c.3333 0 .5 0 .6494.0481a1 1 0 0 1 .358.2047c.1174.1043.202.2479.3712.535L12.0001 9l3.6596-6.2121c.1692-.2872.2538-.4308.3711-.5351a1 1 0 0 1 .3581-.2047C16.5383 2 16.705 2 17.0383 2h2.2348c.8968 0 1.3452 0 1.607.1885.2284.1645.3769.4176.4091.6972.0368.3205-.1819.712-.6194 1.4948l-3.8047 6.8085M10.5001 14l1.5-1v5m-1.25 0h2.5m3.3462-7.0962c2.5384 2.5384 2.5384 6.654 0 9.1924s-6.654 2.5384-9.1924 0-2.5384-6.654 0-9.1924 6.654-2.5384 9.1924 0"
    })
  }));
};
var _default = exports["default"] = Award05;